import BlueprintForm from "./BlueprintForm";
import {useNavigate, useParams} from "react-router-dom";
import {useMutation, useQuery} from "react-query";
import {createNewBlueprint, getBlueprintById} from "../../../../utils/const/query-key";
import apiService from "../../../../api/apiService";
import Loading from "../../Loading";
import React, {useState} from "react";
import MessageModal from "../../../common/MessageModal";
import {MessageModalHelper} from "../../../common/MessageHelper";

const EditBlueprint = () => {
    const {blueprint} = useParams();
    const navigate = useNavigate();
    const goBack = () => {
        navigate("/admin");
    };
    const [open, setOpen] = useState(false);
    const [modal, setModal] = useState({});
    //cacheTime: 0 means make new request each time to show updated data
    const {isLoading, data} = useQuery(getBlueprintById + blueprint, () => apiService.getBlueprintById(blueprint), {cacheTime: 0});
    const {mutate} = useMutation(createNewBlueprint + blueprint, (blueprint) => apiService.createBlueprint(blueprint),
        {
            onSuccess: (status) => {
                MessageModalHelper(setModal,"update",status,goBack);
                setOpen(true);
            },
        }
    );


    const onSubmit = (blueprint) => mutate(blueprint);
    return (
        <div>
            {isLoading ? <Loading/> :
                <div>Demo Point Blueprints / Edit Blueprint
                    {open && <MessageModal open={open} setOpen={setOpen}
                                          modal={modal}/>
                    }
                    <BlueprintForm title={"Edit Blueprint"} blueprint={data} onSubmit={onSubmit}/>
                </div>
            }
        </div>
    )
}
export default EditBlueprint;